<template>
  <div>
    <Head title="Sales Orders" />
    <h1 class="mb-8 text-3xl font-bold">Sales Orders</h1>
    <div class="flex items-center justify-between mb-6">
      <search-with-dropdown-filter v-model="search.search" class="mr-4 w-full max-w-md">
        <label class="block text-gray-700">Channel:</label>
        <select v-model="search.channel" class="form-select mt-1 w-full">
          <option :value="null">-All Channels-</option>
          <option v-for="item in channels" :key="item.id" :value="item.name">
            {{ item.name }}
          </option>
        </select>
      </search-with-dropdown-filter>
      <select-input v-model="search.status" class="mr-4 w-3/4 max-w-md">
        <option :value="null">-Select Status-</option>
        <option v-for="item in statuses" :key="item" :value="item">{{ item }}</option>
      </select-input>
      <date-range
        v-model="search.dateValue"
        class="mr-0 w-full max-w-md"
        @reset="reset"
      />
      <button class="btn-orange text-white-400 hover:text-white-600" @click="searchOrders">Search</button>
      <Link
        v-if="
          user.teams.includes('B2B') ||
          user.teams.includes('Modern Trade') ||
          user.teams.includes('General Trade') ||
          user.role === 'admin'
        "
        class="btn-orange"
        href="/orders/create"
      >
        <span>Create</span>
      </Link>
    </div>
    <hr />
    <ul
      id="tabs-tabFill"
      class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4"
      role="tablist"
    >
      <li class="nav-item flex-auto text-center" role="presentation">
        <a
          id="tabs-home-tabFill"
          href="#tabs-homeFill"
          class="nav-link w-full block font-medium text-xs leading-tight uppercase border-x-0 border-t-0 border-b-2 border-transparent px-6 py-3 my-2 hover:border-transparent hover:bg-gray-100 focus:border-transparent active"
          data-bs-toggle="pill"
          data-bs-target="#tabs-homeFill"
          role="tab"
          aria-controls="tabs-homeFill"
          aria-selected="true"
        >
          <span v-if="user.teams.includes('Finance')">Queue</span>
          <span v-else>Verification Queue</span>
        </a>
      </li>
      <li class="nav-item flex-auto text-center" role="presentation">
        <a
          id="tabs-profile-tabFill"
          href="#tabs-profileFill"
          class="nav-link w-full block font-medium text-xs leading-tight uppercase border-x-0 border-t-0 border-b-2 border-transparent px-6 py-3 my-2 hover:border-transparent hover:bg-gray-100 focus:border-transparent"
          data-bs-toggle="pill"
          data-bs-target="#tabs-profileFill"
          role="tab"
          aria-controls="tabs-profileFill"
          aria-selected="false"
        >
          Processed Orders
        </a>
      </li>
    </ul>
    <div id="tabs-tabContentFill" class="tab-content">
      <div
        id="tabs-homeFill"
        class="tab-pane fade show active"
        role="tabpanel"
        aria-labelledby="tabs-home-tabFill"
      >
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Order Date</th>
              <th class="pb-3 pt-3 px-3">Order Number</th>
              <th class="pb-3 pt-3 px-3">Delivery Date</th>
              <th class="pb-3 pt-3 px-3">Customer</th>
              <th class="pb-3 pt-3 px-3">City</th>
              <th class="pb-3 pt-3 px-3">Zone</th>
              <th class="pb-3 pt-3 px-3">Region</th>
              <th class="pb-3 pt-3 px-3 items-end justify-end">Voucher Amount</th>
              <th class="pb-3 pt-3 px-3 items-end justify-end">Transport</th>
              <th class="pb-3 pt-3 px-3 items-end justify-end">Total Amount</th>
              <th class="pb-3 pt-3 px-3">LPO</th>
              <th class="pb-3 pt-3 px-3">Agent</th>
              <th class="pb-3 pt-3 px-3">Waybill Number</th>
              <th class="pb-3 pt-3 px-3">Status</th>
              <th class="pb-3 pt-3 px-3" colspan="2" />
            </tr>
            <tr
              v-for="order in pending.data"
              :key="order.id"
              class="hover:bg-orange-100 focus-within:bg-gray-100"
            >
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.date }}
                </span>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.order_no }}
                </span>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.delivery_date }}
                </span>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.name }}
                </span>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.town }}
                </span>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.zone }}
                </span>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.region }}
                </span>
              </td>
              <td class="border-t">
                <a
                  v-if="
                    order.voucherInfo &&
                    order.voucherInfo.code &&
                    order.has_discount_voucher == 0
                  "
                  class="flex items-end justify-end px-3 py-3 focus:text-orange-500"
                  @click="openModal(order)"
                >
                  {{ order.voucherInfo.voucher_amount }}
                </a>
                <a
                  v-else
                  class="flex items-end justify-end px-3 py-3 focus:text-orange-500"
                  @click="openModal(order)"
                >
                  0.00
                </a>
              </td>
              <td class="border-t">
                <a
                  class="flex items-end justify-end px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.transport }}
                </a>
              </td>
              <td class="border-t">
                <a
                  class="flex items-end justify-end px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.amount }}
                </a>
              </td>
              <td class="border-t">
                <a v-if="order.lpo_path && order.is_image" href="#" @click="openLpoModal(order)">
                  <span
                    
                    class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-6 h-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13"
                      />
                    </svg>
                  </span>
                </a>
                <a v-if="order.lpo_path && !order.is_image" download target="_blank" :href="`/orders/${order.id}/download/lpos`">
                  <span
                    
                    class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-6 h-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13"
                      />
                    </svg>
                  </span>
                </a>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.agent }}
                </span>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.waybill_no }}
                </span>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.status }}
                </span>
              </td>
              <td class="border-t">
                <Link
                  class="flex items-center px-3"
                  :href="`/orders/${order.id}/edit`"
                  tabindex="-1"
                  title="Edit Order"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                    />
                  </svg>
                </Link>
              </td>
              <td class="w-px border-t">
                <a href="#" @click="openModal(order)" title="View Order">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M8.25 4.5l7.5 7.5-7.5 7.5"
                    />
                  </svg>
                </a>
              </td>
            </tr>
            <tr v-if="pending.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="9">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="pending.links" />
      </div>
      <div
        id="tabs-profileFill"
        class="tab-pane fade"
        role="tabpanel"
        aria-labelledby="tabs-profile-tabFill"
      >
        <div class="bg-white rounded-md shadow overflow-x-auto p-5 mb-5">
          <div class="flex items-center justify-between">
            <a
              class="btn-orange px-3 py-2 text-xs cursor-pointer"
              :href="`/download-orders${url()}`"
              download
              target="__blank"
              title="Download"
            >
              <span>Download</span>
            </a>
          </div>
        </div>
        <hr />
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Order Date</th>
              <th class="pb-3 pt-3 px-3">Order Number</th>
              <th class="pb-3 pt-3 px-3">Delivery Date</th>
              <th class="pb-3 pt-3 px-3">Customer</th>
              <th class="pb-3 pt-3 px-3">City</th>
              <th class="pb-3 pt-3 px-3">Zone</th>
              <th class="pb-3 pt-3 px-3">Region</th>
              <th class="pb-3 pt-3 px-3 items-end justify-end">Voucher Amount</th>
              <th class="pb-3 pt-3 px-3 items-end justify-end">Transport</th>
              <th class="pb-3 pt-3 px-3 items-end justify-end">Total Amount</th>
              <th class="pb-3 pt-3 px-3">LPO</th>
              <th class="pb-3 pt-3 px-3">Agent</th>
              <th class="pb-3 pt-3 px-3">Waybill Number</th>
              <th class="pb-3 pt-3 px-3">Status</th>
              <th class="pb-3 pt-3 px-3" />
            </tr>
            <tr
              v-for="order in orders.data"
              :key="order.id"
              class="hover:bg-orange-100 focus-within:bg-gray-100"
            >
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.date }}
                </span>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.order_no }}
                </span>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.delivery_date }}
                </span>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.name }}
                </span>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.town }}
                </span>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.zone }}
                </span>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.region }}
                </span>
              </td>
              <td class="border-t">
                <span
                  v-if="
                    order.voucherInfo &&
                    order.voucherInfo.code &&
                    order.has_discount_voucher == 0
                  "
                  class="flex items-end justify-end px-3 py-3 focus:text-orange-500"
                  @click="openModal(order)"
                >
                  {{ order.voucherInfo.voucher_amount }}
                </span>
                <span
                  v-else
                  class="flex items-end justify-end px-3 py-3 focus:text-orange-500"
                  @click="openModal(order)"
                >
                  0.00
                </span>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.transport }}
                </span>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.amount }}
                </span>
              </td>
              <td class="border-t">
                <a v-if="order.lpo_path && order.is_image" href="#" @click="openLpoModal(order)">
                  <span
                    
                    class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-6 h-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13"
                      />
                    </svg>
                  </span>
                </a>
                <a v-if="order.lpo_path" download target="_blank" :href="`/orders/${order.id}/download/lpos`">
                  <span
                    
                    class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-6 h-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13"
                      />
                    </svg>
                  </span>
                </a>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.agent }}
                </span>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.waybill_no }}
                </span>
              </td>
              <td class="border-t">
                <span
                  class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
                  @click="openModal(order)"
                >
                  {{ order.status }}
                </span>
              </td>
              <td class="w-px border-t">
                <a href="#" @click="openModal(order)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M8.25 4.5l7.5 7.5-7.5 7.5"
                    />
                  </svg>
                </a>
              </td>
            </tr>
            <tr v-if="orders.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="9">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="orders.links" />
      </div>
    </div>
  </div>
  <div v-if="isOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div
            class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full"
          >
            <h1>
              {{ orderNo }} - {{ orderCustomer }}
              <span v-if="orderStatus === 'Declined'" class="declined">
                [Declined][Reason: {{ reasonDeclined }}]
              </span>
              <span v-else class="approved"> [{{ orderStatus }}] </span>
            </h1>
          </div>
          <div v-if="details.length > 0" class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="bg-orange-50 rounded-md shadow overflow-x-auto mb-4">
              <div class="grid grid-cols-1 gap-4 p-1">
                <div class="pt-2 p-2">
                  <h1 style="font-size: 20px; font-weight: bold">Ordered Details</h1>
                </div>
              </div>
            </div>
            <div class="mb-4 overflow-x-auto">
              <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                  <th class="pb-3 pt-3 px-3">#</th>
                  <th class="pb-3 pt-3 px-3">SKU</th>
                  <th class="pb-3 pt-3 px-3">Description</th>
                  <th class="pb-3 pt-3 px-3">Quantity</th>
                  <th class="pb-3 pt-3 px-3">Unit Price</th>
                  <th class="pb-3 pt-3 px-3">Discount (%)</th>
                  <th class="pb-3 pt-3 px-3 text-end float-right">Amount</th>
                </tr>
                <tr v-for="(item, index) in details" :key="index">
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center px-3">{{ index + 1 }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ item.sku }}</span>
                  </td>
                  <td
                    class="w-px border-t pb-3 pt-3"
                    style="
                      word-wrap: break-word !important;
                      word-break: break-all !important;
                      white-space: normal !important;
                      width: 30%;
                    "
                  >
                    <span class="flex items-left px-3">{{ item.description }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center justify-center px-3">{{
                      item.quantity
                    }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center justify-center px-3">{{
                      item.unit_cost
                    }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center justify-center px-3">{{
                      item.discount
                    }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-end px-3 text-end justify-end">{{
                      item.amount
                    }}</span>
                  </td>
                </tr>
                <tr v-if="orderObj.delivery_fees && orderObj.delivery_fees > 0">
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ details.length + 1 }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{
                      orderObj.transport_name
                    }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{
                      orderObj.transport_description
                    }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center justify-center px-3">1</span>
                  </td>
                  <td class="w-px pb-3 pt-3 border-t border-b">
                    <span class="flex items-center justify-center px-3">{{
                      orderObj.transport_amount
                    }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center justify-center px-3">0</span>
                  </td>
                  <td class="w-px pb-3 pt-3 border-t border-b">
                    <span class="flex items-end px-3 items-end justify-end">{{
                      orderObj.transport_amount
                    }}</span>
                  </td>
                </tr>
                <tr
                  v-if="
                    orderObj.voucherInfo &&
                    orderObj.voucherInfo.code &&
                    orderObj.has_discount_voucher == 0
                  "
                >
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">-</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3" colspan="5">
                    <span class="flex items-left px-3">
                      Voucher Code: #{{ orderObj.voucherInfo.code }} -
                      {{ orderObj.voucherInfo.value }}
                      {{ orderObj.voucherInfo.type === "Percentage" ? "%" : "" }}</span
                    >
                  </td>
                  <td class="pb-3 pt-3 border-t border-b">
                    <span class="flex items-end px-3 items-end justify-end">{{
                      orderObj.voucherInfo.voucher_amount
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <th class="pb-3 pt-3 border-t border-b">Total</th>
                  <th class="pb-3 pt-3 border-t border-b" />
                  <th class="pb-3 pt-3 border-t border-b" />
                  <th class="pb-3 pt-3 border-t border-b" />
                  <th class="pb-3 pt-3 border-t border-b" />
                  <th class="pb-3 pt-3 border-t border-b" />
                  <th class="pb-3 pt-3 border-t border-b">
                    <span class="flex items-end px-3 items-end justify-end">{{
                      orderObj.amount
                    }}</span>
                  </th>
                </tr>
              </table>
            </div>
            <div class="bg-orange-50 rounded-md shadow overflow-x-auto mb-4">
              <div class="grid grid-cols-1 gap-4 p-1">
                <div class="pt-2 p-2">
                  <h1 style="font-size: 20px; font-weight: bold">Payment Details</h1>
                </div>
              </div>
            </div>
            <div v-if="orderObj.payments.length > 0" class="mb-4 overflow-x-auto">
              <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                  <th class="pb-3 pt-3 px-3">#</th>
                  <th class="pb-3 pt-3 px-3">Date</th>
                  <th class="pb-3 pt-3 px-3">Payment Mode</th>
                  <th class="pb-3 pt-3 px-3">Reference</th>
                  <th class="pb-3 pt-3 px-3">Initiated By</th>
                  <th class="pb-3 pt-3 px-3">Phone Number</th>
                  <th class="flex items-end px-3 items-end justify-end">Amount</th>
                </tr>
                <tr v-for="(item, index) in orderObj.payments" :key="index">
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center px-3">{{ index + 1 }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ item.date }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ item.provider }}</span>
                  </td>
                  <td
                    class="w-px border-t pb-3 pt-3 break-all"
                    style="
                      word-wrap: break-word !important;
                      word-break: break-all !important;
                      white-space: normal !important;
                      width: 30%;
                    "
                  >
                    <p class="px-3">{{ item.reference }}</p>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center px-3">{{ item.user }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center px-3">{{ item.phone_number }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-end px-3 items-end justify-end">{{
                      item.amount
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <th class="pb-3 pt-3 border-t border-b">Total</th>
                  <th class="pb-3 pt-3 border-t border-b" />
                  <th class="pb-3 pt-3 border-t border-b" />
                  <th class="pb-3 pt-3 border-t border-b" />
                  <th class="pb-3 pt-3 border-t border-b" />
                  <th class="pb-3 pt-3 border-t border-b" />
                  <th class="pb-3 pt-3 border-t border-b">
                    <span class="flex items-end px-3 items-end justify-end">{{
                      orderObj.total_payments
                    }}</span>
                  </th>
                </tr>
              </table>
            </div>
            <div class="bg-orange-50 rounded-md shadow overflow-x-auto mb-4">
              <div class="grid grid-cols-1 gap-4 p-1">
                <div class="pt-2 p-2">
                  <h1 style="font-size: 20px; font-weight: bold">Notes</h1>
                </div>
              </div>
            </div>
            <div class="mb-4">
              <p v-show="orderObj.notes">{{ orderObj.notes }}</p>
            </div>
          </div>
          <div v-else class="p-5">No order details not found.</div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span
              v-if="
                details.length > 0 &&
                orderStatus === 'Placed' &&
                (user.teams.includes('Finance') || user.role === 'admin')
              "
              class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
            >
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="declineOrder(selectedOrder)"
              >
                Decline
              </button>
            </span>
            <span
              v-if="
                details.length > 0 &&
                orderStatus === 'Placed' &&
                (user.teams.includes('Finance') || user.role === 'admin')
              "
              class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
            >
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-orange-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="openEditPrompt(details)"
              >
                Edit
              </button>
            </span>
            <span
              v-if="
                details.length > 0 &&
                orderStatus === 'Placed' &&
                (user.teams.includes('Finance') || user.role === 'admin')
              "
              class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
            >
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="approveOrder(selectedOrder)"
              >
                Verify
              </button>
            </span>
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                v-show="
                  orderStatus === 'Delivered' || orderStatus === 'Partially Delivered'
                "
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-orange-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm sm:leading-5"
                @click="returnOrderModel()"
              >
                <span>Return</span>
              </button>
            </span>
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                v-show="
                  orderStatus === 'Pick-up'"
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-orange-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm sm:leading-5"
                @click="generateInvoice(orderObj)"
              >
                <span>Generate Invoice</span>
              </button>
            </span>
            <span
              v-show="orderObj.invoice_status === 'completed'"
              class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto"
            >
              <a
                class="btn btn-orange text-xs cursor-pointer ml-1 mr-1"
                :href="`/download-taxilla-pdf-invoices/${orderObj.invoice_id}`"
                download
                target="__blank"
                title="Download"
              >
                <span>Download Invoice</span>
              </a>
            </span>
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeModal"
              >
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isApproveOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1>Verify order</h1>
          </div>
          <div v-if="details.length > 0" class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to verify order number {{ orderNo }}. Do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="submitApproval"
              >
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeApproveModal"
              >
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isAskDeclineOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1>Decline order</h1>
          </div>
          <div v-if="details.length > 0" class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to decline order number {{ orderNo }}. Do you wish to
              continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="openDeclineForm"
              >
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeDeclineAskModal"
              >
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isDeclineFormOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1>Order Decline Reason</h1>
          </div>
          <div
            v-if="order_type == 'normal'"
            class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4"
          >
            <div class="mb-4">
              <select-input v-model="reason" :error="$props.errors.decline_reason">
                <option :value="null">Select the Reason</option>
                <option
                  v-for="theReason in declineReasons"
                  :key="theReason.value"
                  :value="theReason.value"
                >
                  {{ theReason.label }}
                </option>
              </select-input>
            </div>
          </div>
          <div v-else class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <select-input v-model="reason" :error="$props.errors.decline_reason">
                <option :value="null">Select the Reason</option>
                <option
                  v-for="theReason in declineReasonsOnline"
                  :key="theReason.value"
                  :value="theReason.value"
                >
                  {{ theReason.label }}
                </option>
              </select-input>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="submitDecline"
              >
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeDeclineFormModal"
              >
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isLpoOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1>View LPO</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <img :src="`storage/${orderObj.lpo_path}`" width="600" />
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="closeViewLpo"
              >
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isReturnOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex flex-wrap w-full items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-2 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div
            class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full"
          >
            <h1>Return an Order {{ orderNo }}</h1>
          </div>
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <div class="w-full">
                <div
                  v-for="(partial, index) in form.orders"
                  :key="index"
                  class="flex flex-wrap w-full"
                >
                  <div class="pb-2 pr-6 w-full lg:w-full">
                    <text-input
                      :key="index"
                      v-model="partial.quantity"
                      :error="showValidationErrors(`orders.${index}.quantity`)"
                      placeholder="Quantity"
                      :label="`${partial.label}`"
                    />
                  </div>
                  <div class="pb-2 pr-6 w-full lg:w-full">
                    <text-input
                      :key="index"
                      v-model="partial.id"
                      :error="form.errors.id"
                      class="pb-2 hidden"
                      placeholder="ID"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                @click="returnOrder()"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-orange-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm sm:leading-5"
              >
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                @click="closeReturnModal"
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
              >
                Cancel
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isEditModal" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1>Edit Order #{{ orderNo }}</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                  <th class="pb-3 pt-3 px-3">SKU</th>
                  <th class="pb-3 pt-3 px-3">Description</th>
                  <th class="pb-3 pt-3 px-3">Quantity</th>
                  <th class="pb-3 pt-3 px-3">Unit Price</th>
                  <th class="pb-3 pt-3 px-3">Discount (%)</th>
                </tr>
                <tr v-for="(eitem, dindex) in form.orders" :key="dindex">
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ eitem.sku }}</span>
                  </td>
                  <td
                    class="w-px border-t pb-3 pt-3"
                    style="
                      word-wrap: break-word !important;
                      word-break: break-all !important;
                      white-space: normal !important;
                      width: 30%;
                    "
                  >
                    <span class="flex items-left px-3">{{ eitem.description }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ eitem.quantity }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <text-input
                      :key="dindex"
                      v-model="eitem.unit_cost_value"
                      :error="$page.props.errors ? ($page.props.errors[`orders.${dindex}.unit_cost_value`] ||
                      $page.props.errors[`orders.${dindex}.unit_cost_value`]) : false"
                      placeholder="Unit Cost"
                    />
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <text-input
                      :key="dindex"
                      v-model="eitem.discount_value"
                      :error="$page.props.errors ? $page.props.errors[`orders.${dindex}.discount`] : false"
                      placeholder="Discount Rate(%)"
                    />
                    <text-input
                      :key="dindex"
                      v-model="eitem.id"
                      type="hidden"
                    />
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="confirmEditPrompt"
              >
                Update
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                @click="closeEditModal"
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
              >
                Cancel
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isConfirmEditModal" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1>Confirm Order Editing #{{ orderNo }}</h1>
          </div>
          <div v-if="form.orders.length > 0" class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to edit the order SKU unit cost and discount. Do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="updateOrder"
              >
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeEditPrompt"
              >
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import pickBy from "lodash/pickBy";
import Layout from "@/Shared/Layout";
import throttle from "lodash/throttle";
import mapValues from "lodash/mapValues";
import SearchWithDropdownFilter from "@/Shared/SearchWithDropdownFilter";
import Pagination from "@/Shared/Pagination";
import SelectInput from "@/Shared/SelectInput";
import DateRange from "@/Shared/DateRange";
import TextInput from "@/Shared/TextInput";

export default {
  components: {
    Head,
    Link,
    SearchWithDropdownFilter,
    Pagination,
    SelectInput,
    DateRange,
    TextInput,
  },
  layout: Layout,
  props: {
    filters: Object,
    orders: Object,
    declineReasons: Object,
    declineReasonsOnline: Object,
    errors: Object,
    channels: Array,
    statuses: Array,
    pending: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        orders: null,
        order_id: null,
      }),
      search: {
        search: this.filters.search,
        status: this.filters.status,
        dateValue: this.filters.dateValue,
        channel: this.filters.channel,
      },
      isOpen: false,
      isReturnOpen: false,
      orderNo: null,
      orderStatus: null,
      orderCustomer: null,
      details: [],
      total: 0,
      selectedOrder: null,
      isApproveOpen: false,
      orderMessage: "",
      isApprovedOpen: false,
      isLpoOpen: false,
      orderObj: null,
      isAskDeclineOpen: false,
      isDeclineFormOpen: false,
      reason: null,
      decline_reason: null,
      isDeclinedOpen: false,
      reasonDeclined: null,
      orderObj: [],
      isEditModal: false,
      isConfirmEditModal: false
    };
  },
  computed: {
    user() {
      return this.$inertia.page.props.auth.user;
    },
    totalOrder() {
      let totOrder = 0;
      if (this.orderObj.details) {
        this.orderObj.details.forEach((amount) => {
          totOrder += parseFloat(amount.amount);
        });
      }
      return totOrder;
    },
  },
  // watch: {
  //   search: {
  //     deep: true,
  //     handler: throttle(function () {
  //       this.$inertia.get("/orders", pickBy(this.search), { preserveState: true });
  //     }, 150),
  //   },
  // },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null);
    },
    searchOrders() {
      this.$inertia.get('/orders', pickBy(this.search), { preserveState: true })
    },
    openEditPrompt(details) {
      this.form.orders = details;
      this.isOpen = false
      this.isEditModal = true
    },
    closeEditModal() {
      this.isOpen = true
      this.isEditModal = false
    },
    confirmEditPrompt() {
      this.isOpen = false
      this.isEditModal = true
      this.isConfirmEditModal = true
    },
    closeEditPrompt() {
      this.isOpen = true
      this.isEditModal = true
      this.isConfirmEditModal = false
    },
    openModal(data) {
      // this.details = []
      this.isOpen = true;
      this.details = data.details;
      this.form.orders = data.orders;
      this.form.order_id = data.id;
      this.orderNo = data.order_no;
      this.orderStatus = data.status;
      this.orderCustomer = data.name;
      this.total = data.amount;
      this.reasonDeclined = data.decline_reason;
      this.selectedOrder = data.id;
      this.orderObj = data;
    },
    returnOrderModel() {
      this.isAskDeclineOpen = false;
      this.isOpen = false;
      this.isDeclineFormOpen = false;
      this.isLpoOpen = false;
      this.isReturnOpen = true;
    },
    closeReturnModal() {
      this.isReturnOpen = false;
    },
    closeModal() {
      this.isOpen = false;
    },
    declineOrder() {
      this.isAskDeclineOpen = true;
    },
    approveOrder() {
      this.isApproveOpen = true;
    },
    closeApproveModal() {
      this.isApproveOpen = false;
    },
    closeDeclineAskModal() {
      this.isAskDeclineOpen = false;
    },
    openDeclineForm() {
      this.isDeclineFormOpen = true;
    },
    closeDeclineFormModal() {
      this.isDeclineFormOpen = false;
    },
    openLpoModal(data) {
      this.isLpoOpen = true;
      this.orderObj = data;
    },
    closeViewLpo() {
      this.isLpoOpen = false;
    },
    isValidationErrors(value) {
      if (this.form.errors) {
        const error = this.form.errors[value] || "";
        return !!error;
      }
      return false;
    },
    showValidationErrors(value) {
      if (this.form.errors) {
        const error = this.form.errors[value] || "";
        return error || "";
      }
      return "";
    },
    updateOrder() {
      this.form._method = 'post'
      this.$inertia.post(`/verifications/orders/${this.selectedOrder}/update`, this.form, {
        onSuccess: () => {
          this.form.orders = null
          this.isOpen = false
          this.isEditModal = false
          this.isConfirmEditModal = false
        },
        onError: (error) => {
          this.popUpErrors = error
          this.isConfirmEditModal = false
        },
      })
    },
    submitApproval() {
      const data = {};
      data.id = this.selectedOrder;
      data._method = "POST";
      this.$inertia.post(`/approve-order/${this.selectedOrder}`, data);
      this.isApproveOpen = false;
      this.isOpen = false;
      this.isAskDeclineOpen = false;
      this.isDeclineFormOpen = false;
    },
    submitDecline() {
      const data = {};
      data.id = this.selectedOrder;
      data.decline_reason = this.reason;
      data._method = "POST";
      this.$inertia.post("/decline-order", data, {
        onSuccess: () => {
          this.isAskDeclineOpen = false;
          this.isDeclineFormOpen = false;
          this.isApproveOpen = false;
          this.isOpen = false;
        },
      });
    },
    returnOrder() {
      this.form.post(`/orders/${this.form.order_id}/skus/return`, {
        onSuccess: () => {
          this.form.reset("orders");
          this.isReturnOpen = false;
        },
      });
    },
    url() {
      let query = "";
      if (this.search.search) {
        query += `search=${this.search.search}`;
      }
      if (this.search.channel) {
        if (query) {
          query += "&";
        }
        query += `channel=${this.search.channel}`;
      }
      if (this.search.dateValue) {
        if (query) {
          query += "&";
        }
        query += `dateValue=${this.search.dateValue}`;
      }
      if (this.search.status) {
        if (query) {
          query += "&";
        }
        query += `status=${this.search.status}`;
      }
      if (query) {
        query = `?${query}`;
      }
      return query;
    },
    pdfUrl() {
      let query = "";
      if (this.orderObj) {
        query += `oid=${this.orderObj.id}`;
      }
      if (query) {
        query = `?${query}`;
      }
      return query;
    },
    generateInvoice(order) {
      this.processing = true;
      this.$inertia.post(`/pick-up-order/invoice-validation/?orderId=${order.id}`, {
        onSuccess: () => {
          this.processing = false;
        },
      });
    },
  },
};
</script>

<style>
.modal-wrapper h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 10px;
}
.approved {
  color: green;
}
.declined {
  color: red;
}
</style>
